import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserService } from '../../services/user.service';
import { AlertsService } from '../../services/alerts.service';

interface User {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;
}

/**
 * Component for managing a user's account details.
 */
@Component({
	selector: 'user-details',
	templateUrl: './details.component.html',
	styleUrl: './details.component.css'
})
export class DetailsComponent implements OnInit, OnDestroy {
	
	private userServiceSubscription!: Subscription;

	LOCALIZATION: any;

	user: User = {
		firstName: '',
		lastName: '',
		email: '',
		phone: ''
	};

	constructor(
		private alertsService: AlertsService,
		private userService: UserService
	) { }

	ngOnInit(): void {
		this.userServiceSubscription = this.userService.broadcastEvent.subscribe((eventId: string) => {
			if ("localizationLoaded" === eventId) {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});	
		
		
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loadUser();
	}
	
	ngOnDestroy(): void {
		if (this.userServiceSubscription) {
			this.userServiceSubscription.unsubscribe();
		}
	}

	private loadUser(): void {
		this.user = {
			firstName: this.userService.user.firstName ?? '',
			lastName: this.userService.user.lastName ?? '',
			email: this.userService.user.email ?? '',
			phone: this.userService.user.phone ?? ''
		};
	}

	updateUser(): void {
		if ((!this.user.firstName) || (!this.user.lastName) || (!this.user.email)) {
			this.alertsService.error({
				message: this.LOCALIZATION.fillAllFields,
				delay: 5000
			});
			return;
		}

		let payload = {
			firstName: this.user.firstName,
			lastName: this.user.lastName,
			email: this.user.email,
			phone: this.user.phone,
			theme: this.userService.user?.theme || this.userService.getLocalStorageData().theme
		};

		this.userService.updatePartialUser(payload).then(
			(response: any) => {
				this.alertsService.success({
					message: this.LOCALIZATION.userProfileUpdateSuccess,
					delay: 5000
				});
			},
			(err: any) => {
				console.error("Failed to update user details.", err);
				this.alertsService.error({
					message: this.LOCALIZATION.userProfileUpdateError,
					delay: 5000
				});
			}
		);
	}
}
